import MemoryDB from "./memoryDb";
import RefManager from "./refManager";

export const db = new MemoryDB({ primaryKeys: { metadata: "GENERATE" } });
export const refManager = new RefManager({ db });
